export enum WorkforceMetricsMode {
  BillableUtilization = "billableUtilization",
  TotalUtilization = "totalUtilization",
  TotalAvailability = "totalAvailability"
}
